import React, { useState } from "react";
import { Box } from "@mui/material";
import { MainContainer } from "../../../components/ContentWrapper";
import { WhiteBackground } from "../../../components/WhiteBackground";
import { PageTitle } from "../../../components/PageTitle";
import { TabHeader } from "../../../components/Tabs/TabHeader";
import { PricingProvider } from "./PricingContext";
import { ContentTypesTab } from "./ContentTypesTab";
import { ChannelsTab } from "./ChannelsTab";
import { PlacementsTab } from "./PlacementsTab";
import { Licenses } from "./Licenses";
import { ProjectCountTiers } from "./ProjectCountTiers";
import { MatchingProductTiers } from "./MatchingProductTiers";
import { Packages } from "./Packages";
import { PricingExplanation } from "./PricingExplanation";
import { PlansTab } from "./PlansTab";
import { UsageRatesTab } from "./UsageRatesTab";

const TABS = [
    { value: 0, text: "Content Types" },
    { value: 1, text: "Channels" },
    { value: 2, text: "Placements" },
    { value: 3, text: "Licenses" },
    { value: 4, text: "Project Count Tiers" },
    { value: 5, text: "Matching Product Tiers" },
    { value: 6, text: "Packages" },
    { value: 7, text: "Pricing Explanation" },
    { value: 8, text: "Plans" },
    { value: 9, text: "Usage Rates" }
];

const PricingPage = () => {
    const [tab, setTab] = useState(0);

    return (
        <WhiteBackground>
            <MainContainer>
                <Box className="w-full flex flex-wrap justify-between items-center gap-3 pb-2">
                    <PageTitle title="Pricing" />
                </Box>
                <PricingProvider>
                    <Box className="flex flex-col gap-4">
                        <TabHeader
                            tabs={TABS}
                            selectedTab={tab}
                            setSelectedTab={setTab}
                            variant="underline"
                        />
                        {tab === 0 && <ContentTypesTab />}
                        {tab === 1 && <ChannelsTab />}
                        {tab === 2 && <PlacementsTab />}
                        {tab === 3 && <Licenses />}
                        {tab === 4 && <ProjectCountTiers />}
                        {tab === 5 && <MatchingProductTiers />}
                        {tab === 6 && <Packages />}
                        {tab === 7 && <PricingExplanation />}
                        {tab === 8 && <PlansTab />}
                        {tab === 9 && <UsageRatesTab />}
                    </Box>
                </PricingProvider>
            </MainContainer>
        </WhiteBackground>
    );
};

export default PricingPage;
